import React, { useEffect, useState } from 'react';
import { CommonWrapper } from '../../CommonWrapper';
import RadioGroup from 'ds/components/input/RadioGroup';
import { useLocale } from 'locale';
import { Button } from 'ds/components/button';
import { Nav } from '../../styled';
import { IInvestmentGoal } from 'store/sagas/apiService/types';
import { useScreenBreakpoint } from 'consts/breakpoints';


interface IImportantArea {
  isActive: boolean;
  isSaved: boolean;
  title: string;
  text?: string;
  btnText?: string;
  setArea: any;
  data: string;
  onUpdate: (data: { [key: string]: any }) => void;
  selfClick?: () => void;
  fullActive?: boolean;
}

export const ImportantArea: React.FC<IImportantArea> = ({ isActive, isSaved, title, text, btnText, data, onUpdate, setArea, selfClick, fullActive }) => {
  const { t } = useLocale();
  const [ value, setValue ] = useState(null);
  const screen = useScreenBreakpoint();
  const isMobile = screen === 1;

  useEffect(() => {
    setValue(data);
  }, [ data ]);

  const handleRadioChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
  };

  const handleSubmit = () => {
    setArea();
    onUpdate({ goal: value });
  };

  return (
    <CommonWrapper {...{ isActive, isSaved, title, text, selfClick }}>
      <>
        <RadioGroup
          value={value}
          onChange={handleRadioChange}
          name="importantArea"
          options={[
            { label: t('investors.important.value', { value: IInvestmentGoal.Appreciation }), value: IInvestmentGoal.Appreciation },
            { label: t('investors.important.value', { value: IInvestmentGoal.RentalYield }), value: IInvestmentGoal.RentalYield },
            { label: t('investors.important.value', { value: IInvestmentGoal.Balance }), value: IInvestmentGoal.Balance },
          ]}
        />
        {isActive ? (
          <Nav>
            <Button size="extraLarge" fullWidth={isMobile} disabled={fullActive ? (!value || value === data) : !value} onClick={handleSubmit}>{btnText || t('investors.wizard.submitButton')}</Button>
          </Nav>
        ) : null}
      </>
    </CommonWrapper>
  );
};
